<template>
  <div
    class="auto-grid"
    :style="{
      '--gutter': gutter,
      '--auto-grid-placement': placement,
      '--auto-grid-min-item-size': minItemSize,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    gutter: {
      type: String,
      required: false,
      default: "",
    },
    placement: {
      type: String,
      required: false,
      default: "",
    },
    minItemSize: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {},
};
</script>

<style lang="scss">
.auto-grid {
  display: grid;
  gap: var(
    --gutter,
    var(--global-space)
  ); // Set a space for gap with default size as a fallback;

  @supports (width: min(250px, 100%)) {
    grid-template-columns: repeat(
      var(--auto-grid-placement, auto-fit),
      minmax(min(var(--auto-grid-min-item-size, 250px), 100%), 1fr)
    );
  }
}
</style>
